<template>
<div id="container" class="container">
  <img
    class="rocket"
    :src="$image('normal/buttons/decoration/rocket-ready.svg')"
    alt=""
  />
  <img
    class="fire"
    ref="fire"
    :src="$image('rocket_flame.svg')"
    alt=""
  />
</div>
</template>

<script>
import gsap from 'gsap';

export default {
  data() {
    return {
      isLaunch: false,
    };
  },
  mounted() {
    // const container = document.querySelector('.container');

    // container.animate(
    //   [
    //     { backgroundPosition: 'bottom 0% center' },
    //     { backgroundPosition: 'bottom 100% center' },
    //   ],
    //   {
    //     duration: 3 * 1000,
    //     iterations: 1,
    //     fill: 'forwards',
    //   },
    // );


    // setTimeout(() => {
    //   this.isLaunch = true;
    // }, 1000);

    const tl = gsap.timeline();

    tl.to(".container", {
      duration: 3,
      backgroundPosition: '0 0',
      delay: 1,
      ease: 'power1.inOut',
      onStart: () => {
        this.$sound.rocket().play();
      },
      onComplete: () => {
        this.$store.commit("app/setCurrentView", "ViewStageBonus");
      },
    });

    const fireTl = gsap.timeline();

    fireTl.fromTo(this.$refs.fire,{
      scale: 0,
    }, {
      duration: 2,
      scale: 1,
      transformOrigin: 'center top',
    });

    fireTl.to(this.$refs.fire, {
      duration: 0.3,
      scale: 0.7,
      transformOrigin: 'center top',
      repeat: -1,
      yoyo: true,
    });
    // const rocket = document.createElement('img');
    // rocket.src = require('@/assets/img/rocket.png');
    // rocket.style.width = '100px';
    // rocket.style.height = '100px';
    // rocket.style.position = 'absolute';
    // rocket.style.top = '0';
    // rocket.style.left = '0';
    // container.appendChild(rocket);

    // const keyframes = [
    //   { top: '0', left: '0' },
    //   { top: '100px', left: '100px' },
    //   { top: '200px', left: '200px' },
    //   { top: '300px', left: '300px' },
    //   { top: '400px', left: '400px' },
    //   { top: '500px', left: '500px' },
    //   { top: '600px', left: '600px' },
    //   { top: '700px', left: '700px' },
    //   { top: '800px', left: '800px' },
    //   { top: '900px', left: '900px' },
    //   { top: '1000px', left: '1000px' },
    // ];

    // rocket.animate(keyframes, {
    //   duration: 3000,
    //   iterations: 1,
    //   fill: 'forwards',
    // });
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('~@/assets/img/background_rocket.png');
  background-size: cover;
  background-position:  0 100%;

  .rocket {
    width: calc(var(--size-base) * 200);
    position: relative;
    bottom: 10%;
    z-index: 10;
  }

  .fire {
    width: calc(var(--size-base) * 200);
    position: absolute;
    bottom: 20%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
  }
}
</style>